module.exports = __webpack_public_path__ + "static/media/file_upload_preview.794f1ae8.png";